import React, { Component } from "react";
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import AjaxTable from '../common/tables/AjaxTable';
import { getRecordsTableColumns, defaultRecord } from './columns/VDNSRecordsColumns';
import getServicesTableColumns from './columns/VDNSServicesColumns';
import getClustersTableColumns from './columns/VDNSClusterColumns';
import vdns_api from '../services/vdns_api';

export default class VDNSManager extends Component {
  static propTypes = {
    auth: PropTypes.object
  }

  render () {
    const { auth } = this.props;
    return (
      <>
        { auth &&
        <>
          <Route
            path="/vdns_manager/records"
            render={ props => <AjaxTable
              { ...props}
              authToken={auth.token}
              title={'VDNS Records'}
              getColumns={getRecordsTableColumns}
              updateData={vdns_api.updateRecord}
              selectData={vdns_api.getAllRecords}
              createData={vdns_api.createRecord}
              defaultData={defaultRecord}
              deleteData={vdns_api.deleteRecord}
              searchable={true}
            />}
          />
          <Route
            path="/vdns_manager/clusters"
            render={ props => <AjaxTable
              { ...props}
              authToken={auth.token}
              title={'VDNS Clusters'}
              getColumns={getClustersTableColumns}
              updateData={vdns_api.updateCluster}
              selectData={vdns_api.getAllClusters}
            />}
          />
          <Route
            path="/vdns_manager/services"
            render={ props => <AjaxTable
              { ...props}
              authToken={auth.token}
              title={'VDNS Services'}
              getColumns={getServicesTableColumns}
              updateData={vdns_api.updateService}
              selectData={vdns_api.getAllServices}
            />}
          />
        </>
        }
      </>
    );
  }
}